<template>
  <div>
    <v-card flat tile>
      <v-card-text class="pl-0 mt-10 pt-0">
        <div>
          <v-row class="mb-1 col-8 pl-0">
            <v-col class="d-inline-block pl-0 pr-0" cols="7" height="50px">
              <v-file-input
                chips
                label="클릭하여 엑셀 파일을 업로드해주세요."
                class="pt-1 pl-1"
                v-model="excelFile"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              ></v-file-input>
            </v-col>
            <v-col class="d-inline-block pl-0" height="50px">
              <v-btn
                depressed
                color="black white--text ml-5"
                large
                @click.prevent="readFile"
                >업로드하기</v-btn
              >
            </v-col>
          </v-row>
        </div>

        <div>
          <p class="mb-0 body-2 font-weight-Bold mt-1 green--text">
            기존 상품에 시리얼코드(인증코드)가 있는 경우 시스템에 등록하여
            사용할 수 있습니다.
          </p>
          <p class="mb-0 body-2 font-weight-Bold green--text">
            보안이슈로 % ? / \ 특수기호는 등록되지 않으니 참고해주세요.
          </p>
          <p class="mb-5 body-2 font-weight-Bold green--text lighten-2">
            엑셀 업로드 양식에 맞게 입력하여 등록해주세요.
          </p>
        </div>

        <div>
          <p class="mb-0 body-2 font-weight-light mt-1 black--text">
            [카페24어드민 > 상점관리 > 통합엑셀 > 엑셀파일 요청] 메뉴의
          </p>
          <p class="mb-0 body-2 font-weight-light black--text">
            조건설정 '상품관리 - 품목' 탭 메뉴에서 등록된 카페24 품목 정보를
            엑셀 다운로드 받아서 사용합니다.
          </p>
          <p class="mb-0 body-2 font-weight-light black--text">
            이후 아래의 엑셀업로드 파일 양식에 맞게 입력하여 등록해주세요.
          </p>
          <p class="mb-0 body-2 font-weight-light black--text">
            ※ 엑셀 파일의 형식은 .xls .xlsx / 파일 용량은 최대 10MB - 큰 용량일
            경우 나누어 업로드합니다.
          </p>

          <v-btn
            depressed
            color="teal"
            class="mt-3 white--text mb-0"
            @click.prevent="excelSampleDownLoad"
            >엑셀업로드 양식 다운로드</v-btn
          >
        </div>

        <div class="col-12 pl-0 pb-0" v-if="failSheetData.length > 0">
          <div class="pt-0 pb-0 pl-0 pt-3">
            <strong
              class="mb-0 body-2 font-weight-blod black--text pt-0 pb-0 mt-0"
            >
              [총
              <font class="font-weight-bold">{{
                sheet.totalCount | numberFormat
              }}</font
              >개 -
              <font class="font-weight-bold">
                {{
                  (sheet.totalCount - failSheetData.length) | numberFormat
                }} </font
              >개 정상 /
              <font class="font-weight-bold">{{
                failSheetData.length | numberFormat
              }}</font
              >개 실패] 업로드한 상품 중 실패된 정보를 확인하시고
              재등록해주세요.
            </strong>
          </div>
        </div>

        <v-card
          class="col-12 col-md-12 mt-2 mb-4 pt-0 pb-0"
          v-if="failSheetData.length > 0"
        >
          <v-data-table
            :headers="headersAddList"
            :items="failSheetData"
            :items-per-page="20"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50],
              'items-per-page-text': '목록 노출 수 선택:',
            }"
          >
            <template
              v-slot:[`item.product_info`]="{ item }"
              class="pl-0 pr-0 ml-0 mr-0"
            >
              <v-row no-gutters>
                <v-col :cols="11" class="pl-0 pr-0 ml-0 mr-0">
                  <p class="mb-0 mt-3 mr-0 text-left text-truncate caption">
                    상품명 : {{ item.product_name }}
                  </p>
                  <p class="mb-0 mr-0 text-left text-truncate caption">
                    품목명 : {{ item.variant_name }}
                  </p>
                  <p class="mb-0 mr-0 text-left text-truncate caption">
                    상품코드 : {{ item.product_code }}
                  </p>
                  <p class="mb-3 mr-0 text-left text-truncate caption">
                    품목코드 : {{ item.variant_code }}
                  </p>
                </v-col>
              </v-row>
            </template>

            <template
              v-slot:[`item.activate_type`]="{ item }"
              class="pl-0 pr-0 ml-0 mr-0"
            >
              <v-row no-gutters>
                <v-col :cols="11" class="pl-0 pr-0 ml-0 mr-0">
                  {{ item.activate_type | defaultString }}
                </v-col>
              </v-row>
            </template>

            <template
              v-slot:[`item.duration_type`]="{ item }"
              class="pl-0 pr-0 ml-0 mr-0"
            >
              <v-row no-gutters>
                <v-col :cols="11" class="pl-0 pr-0 ml-0 mr-0">
                  {{ item.duration_type | defaultString }}
                </v-col>
              </v-row>
            </template>

            <template
              v-slot:[`item.duration`]="{ item }"
              class="pl-0 pr-0 ml-0 mr-0"
            >
              <v-row no-gutters>
                <v-col :cols="11" class="pl-0 pr-0 ml-0 mr-0">
                  {{ item.duration | defaultString }}
                </v-col>
              </v-row>
            </template>

            <template
              v-slot:[`item.serial_number`]="{ item }"
              class="pl-0 pr-0 ml-0 mr-0"
            >
              <v-row no-gutters>
                <v-col :cols="11" class="pl-0 pr-0 ml-0 mr-0">
                  {{ item.serial_number | defaultString }}
                </v-col>
              </v-row>
            </template>

            <template
              v-slot:[`item.error`]="{ item }"
              class="pl-0 pr-0 ml-0 mr-0"
            >
              <v-row no-gutters>
                <v-col
                  :cols="11"
                  class="pl-0 pr-0 ml-0 mr-0"
                  style="color:rgb(192, 57, 43);"
                  v-html="$options.filters.excelErrorMessages(item.messages)"
                ></v-col>
              </v-row>
            </template>
            <template slot="no-data">
              <div class="noDataProductInfos">내역이 없습니다.</div>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>
    <v-row justify="center">
      <v-dialog persistent max-width="280" v-model="generateSerialsDialog">
        <v-card>
          <v-card-title class="headline">완료되었습니다.</v-card-title>
          <v-card-text>
            <p class="mb-0">생성된 정품 인증 코드 내역은</p>
            <p class="mb-0">[정품 인증 코드 관리]</p>
            <p class="mb-0">메뉴에서 확인이 가능합니다.</p>
            <p class="mb-0">※ 엑셀 다운로드 및 인쇄 가능</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="black darken-1"
              text
              @click.prevent="generateSerialsDialog = false"
              >닫기</v-btn
            >
            <v-btn
              color="blue darken-1"
              @click.prevent="moveManageAuthcode"
              text
              >확인하러가기</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<style scoped>
.noDataProductInfos {
  padding: 50px 0;
}
</style>
<script>
import M from "@/libs/mapping.js";
import Excel from "@/libs/excel.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import Filters from "@/libs/authservice/filters.js";

export default {
  data() {
    return {
      styleSize: {
        width: "70px",
        height: "50px",
      },
      selectStyleSize: {
        width: "180px",
        height: "50px",
      },
      headersAddList: [
        {
          text: "품목정보",
          align: "center",
          value: "product_info",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
        },
        {
          text: "상품코드",
          align: "center",
          value: "product_code",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: 100,
        },
        {
          text: "품목코드",
          align: "center",
          value: "variant_code",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: 100,
        },
        {
          text: "실패사유",
          align: "center",
          value: "error",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: 250,
        },
      ],
      excelFile: null,
      sheetHeaderTitle: {
        상품코드: "product_code",
        품목코드: "variant_code",
        상품명: "product_name",
        품목명: "variant_name",
        "매칭 인증코드 정보": "serial_number",
      },
      errorMsg: {
        product_code: "상품코드 오류",
        variant_code: "품목코드 오류",
        product_name: "상품명 오류",
        variant_name: "품목명 오류",
        serial_number: "매칭 인증코드 정보 오류",
      },
      send: {
        data: [],
        divisionData: [],
        dataTotalCount: 0,
        limit: 20,
        totalCount: 0,
        index: 0,
      },
      sheet: {
        data: [],
        totalCount: 0,
      },
      failSheetData: [],
      generateSerialsDialog: false,
      durationType: "",
      durationCount: "",
      durationKind: "",
    };
  },
  mixins: [CommonMixin],
  props: ["duration"],
  filters: Filters,
  methods: {
    /**
     * 파일 읽기
     */
    readFile: async function() {
      let maxSize = 10 * 1024 * 1024;
      if (!this.excelFile) {
        this.alertShow("엑셀파일을 업로드해주세요");
        return false;
      }

      let fileSize = this.excelFile.size;
      if (fileSize > maxSize) {
        this.alertShow("엑셀파일 사이즈를 10MB 이내로 업로드해주세요.");
        return false;
      }

      let progressText =
        "입력한 상품의 정품 인증 코드가 발급중입니다.</br>잠시만 기다려 주세요.";
      this.circularProgressShow(progressText);
      let ProductExcel = new Excel(this.excelFile, this.sheetHeaderTitle);
      this.sheet.data = await ProductExcel.getJson();
      this.sheet.totalCount = this.sheet.data.length;
      if (this.sheet.totalCount === 0) {
        this.alertShow("엑셀파일에 업로드할 데이터가 없습니다.");
        this.circularProgressHide();
        return false;
      }
      this.execExcelUpload();
    },
    /**
     * 업로드실행준비
     */
    execExcelUpload: async function() {
      this.failSheetData = [];
      await this.checkSheetData();
      this.setSendData();
      this.progressUpload(0);
    },
    /**
     * 엑셀 데이터 체크
     */
    checkSheetData: async function() {
      for (let i = 0; i < this.sheet.totalCount; i++) {
        let prd = this.sheet.data[i];
        prd["messages"] = [];
        await this.issetCheck(prd)
          // 클라이언트에서 체크 안함 서버에서 체크하기로함.
          // .then(this.checkProductCode)
          // .then(this.checkVariantCode)
          .then(this.checkDurationType)
          .then(this.checkNumberDays)
          //.then(this.checkNumberSerial)
          .then(this.patternNumberSerial)
          .catch(this.addFailData)
          .then((prd) => {
            if (prd !== undefined) {
              this.send.data.push(prd);
            }
          });
      }
      this.send.dataTotalCount = this.send.data.length;
    },
    /**
     * 필수값 체크
     */
    issetCheck: function(prd) {
      let $this = this;
      return new Promise(function(resolve, reject) {
        let checkTitle = ["product_code", "variant_code", "serial_number"];
        checkTitle.forEach((key) => {
          let hasKey = Object.prototype.hasOwnProperty.call(prd, key);
          if (!hasKey) {
            prd["messages"].push($this.errorMsg[key]);
            reject(prd);
            return false;
          }
        });
        resolve(prd);
      });
    },
    /**
     * 상품코드 체크
     */
    checkProductCode: function(prd) {
      let $this = this;
      return new Promise(function(resolve, reject) {
        if (!/[A-Z0-9]/.test(prd["product_code"])) {
          prd["messages"].push($this.errorMsg["product_code"]);
          reject(prd);
          return false;
        }
        resolve(prd);
      });
    },
    /**
     * 품목 체크
     */
    checkVariantCode: function(prd) {
      let $this = this;
      return new Promise(function(resolve, reject) {
        if (!/[A-Z0-9]/.test(prd["variant_code"])) {
          prd["messages"].push($this.errorMsg["variant_code"]);
          reject(prd);
          return false;
        }
        resolve(prd);
      });
    },
    /**
     * 타입체크
     */
    checkDurationType: function(prd) {
      let $this = this;
      return new Promise(function(resolve, reject) {
        let hasKey = Object.prototype.hasOwnProperty.call(prd, "activate_type");
        if (hasKey && !["A", "C"].includes(prd["activate_type"])) {
          prd["messages"].push($this.errorMsg["activate_type"]);
          reject(prd);
          return false;
        }
        resolve(prd);
      });
    },
    /**
     * 개월타입
     */
    checkDurationDaysType: function(prd) {
      let $this = this;
      return new Promise(function(resolve, reject) {
        let hasKey = Object.prototype.hasOwnProperty.call(prd, "duration_type");
        if (hasKey && !["D", "M", "Y"].includes(prd["duration_type"])) {
          prd["messages"].push($this.errorMsg["duration_type"]);
          reject(prd);
          return false;
        }
        resolve(prd);
      });
    },
    /**
     * 숫자 체크
     */
    checkNumberDays: function(prd) {
      let $this = this;
      return new Promise(function(resolve, reject) {
        let hasKey = Object.prototype.hasOwnProperty.call(prd, "duration");
        if (hasKey && !/[0-9]/.test(prd["duration"])) {
          prd["messages"].push($this.errorMsg["duration"]);
          reject(prd);
          return false;
        }
        resolve(prd);
      });
    },
    /**
     * 숫자 체크
     */
    checkNumberSerial: function(prd) {
      let $this = this;
      return new Promise(function(resolve, reject) {
        if (!/[0-9]/.test(prd["serial_number"])) {
          prd["messages"].push($this.errorMsg["serial_number"]);
          reject(prd);
          return false;
        }
        resolve(prd);
      });
    },
    /**
     * 패턴 체크
     */
    patternNumberSerial: function(prd) {
      let $this = this;
      return new Promise(function(resolve, reject) {
        if (/[%₩/\\?]/.test(prd["serial_number"])) {
          prd["messages"].push($this.errorMsg["serial_number"]);
          reject(prd);
          return false;
        }
        resolve(prd);
      });
    },
    /**
     * 실패한 상품 데이터
     */
    addFailData: function(data) {
      this.failSheetData.push(data);
    },

    /**
     * 전송 데이터 셋팅
     */
    setSendData: function() {
      this.send.divisionData = [];
      this.send.totalCount = Math.floor(
        this.send.dataTotalCount / this.send.limit
      );
      for (var i = 0; i <= this.send.totalCount; i++) {
        let params = this.send.data.splice(0, this.send.limit);

        for (let param of params) {
          param.serial_number = `${param.serial_number}`;
        }

        this.send.divisionData.push(params);
      }
    },
    /**
     * 엑셀 업로드 진행
     */
    progressUpload: async function(index) {
      this.circularProgressSetValue(
        Math.round((index / this.send.totalCount) * 100)
      );
      if (index > this.send.totalCount) {
        setTimeout(() => {
          this.circularProgressHide();
          if (this.sheet.totalCount - this.failSheetData.length > 0) {
            this.generateSerialsDialog = true;
          }
        }, 1000);
        return false;
      }
      await this.sendExcelData(index);
    },
    /**
     * 데이터 전송
     */
    sendExcelData: async function(index) {
      if (this.send.divisionData[index].length === 0) {
        index++;
        await this.progressUpload(index);
        return false;
      }

      for (let i = 0; i < this.send.divisionData[index].length; i++) {
        //보증기간 기준 설정 (생성일, 인증일)
        if (!this.send.divisionData[index][i].activate_type) {
          this.send.divisionData[index][i].activate_type = this.durationType;
        }
        //보증기간 일자 설정 ( 숫자 )
        if (!this.send.divisionData[index][i].duration) {
          this.send.divisionData[index][i].duration = this.durationCount;
        }
        //보증기간 타입 설정 ( 연, 월, 일)
        if (!this.send.divisionData[index][i].duration_type) {
          this.send.divisionData[index][i].duration_type = this.durationKind;
        }

        //특수기호 체크
        let pattern = /[%₩/\\?]/;
        let patternInfo = pattern.test(
          this.send.divisionData[index][i].serial_number
        );

        if (patternInfo === true) {
          this.send.divisionData[index][i]["messages"].push(
            "특수기호 등록 에러"
          );
          this.addFailData(this.send.divisionData[index][i]);
        }

        try {
          let payload = {
            serial_number: this.send.divisionData[index][i].serial_number,
          };
          let data = await M.api(M.entry("/cert/serials/search"), payload);
          if (data.count > 0) {
            this.send.divisionData[index][i]["messages"].push(
              "기등록 정품코드 에러"
            );
            this.addFailData(this.send.divisionData[index][i]);
          }
        } catch (e) {
          //
        }
      }

      try {
        let res = await M.api(
          M.entry("/exists/serials/excel"),
          this.send.divisionData[index]
        );

        if (res.fails.length > 0) {
          res.fails.forEach((fail) => {
            this.addFailData(fail);
          });
        }
      } catch (e) {
        this.send.divisionData[index].forEach((prd) => {
          prd["messages"].push("API 에러");
          this.addFailData(prd);
        });
      }

      index++;
      await this.progressUpload(index);
    },
    /**
     * 파일다운
     */
    excelSampleDownLoad: function() {
      var url = "/authservice/etc/sample/소프트웨어인증_엑셀업로드양식.xlsx";
      location.href = url;
    },
    /**
     * page 이동
     */
    moveManageAuthcode: function() {
      this.$router.push({
        path: `/authservice/${this.$store.state.mallId}/manageAuthcode`,
      });
    },
  },
  created: async function() {
    try {
      let data = await M.api(M.entry("/get/duration"), {});
      if (data) {
        if (data.duration_type == "created") {
          this.durationType = "C";
        } else {
          this.durationType = "A";
        }
        this.durationCount = data.duration.replace(/[a-z]/gi, "");
        this.durationKind = data.duration.replace(/[0-9]/g, "");
      }
    } catch (e) {
      this.alertShow("정품 보증기간 설정 조회가 실패되었습니다.");
    }
  },
};
</script>
